import { defineFetch } from 'resift';

const makeGetWidgetTypes = defineFetch({
  displayName: 'Get Widget Types',
  make: () => ({
    request: (expandDefaultLayoutPresence?: boolean) => ({ http }) =>
      http({
        method: 'GET',
        route: `/widget-types`,
        query: { expandDefaultLayoutPresence },
      }),
  }),
});

const getWidgetTypes = makeGetWidgetTypes();

export default getWidgetTypes;
